import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
import Note from './note';
const RoomNote = ({ onSave, disableEditing, noteText }) => {
    const saveStreemshotNote = (note) => {
        onSave && onSave(note);
    };
    const theme = useTheme();
    return (_jsx(Note, { placeholderText: "Add notes to a streem", noteText: noteText, disableAutoGrow: true, style: {
            height: 'calc(100% - 20px)',
        }, textareaStyle: { background: theme.colors.white }, characterLimit: 1700, onSave: saveStreemshotNote, disableEditing: disableEditing }));
};
export default RoomNote;
//# sourceMappingURL=room_note.js.map